export enum Event {

	LoggedIn,
	LoggedOut,
	Unauthorized,
	RightsReceived
}

type VoidFunction = (...params: any[]) => void;

export abstract class EventDispatcher {

	public static register(event: Event, callback: VoidFunction) {

		// Get Event Callbacks
		let callbacks: Set<VoidFunction> | undefined = EventDispatcher.handlers.get(event);

		// Check If We Have A Callback Set
		if (callbacks === undefined) {

			// Initialize Callback Set
			callbacks = new Set<VoidFunction>();

			// Add Callback Set To Event
			EventDispatcher.handlers.set(event, callbacks);
		}

		// Add Callback To Event Callbacks
		callbacks.add(callback);
	}

	public static unregister(event: Event, callback: VoidFunction) {

		// Get Event Callbacks
		const callbacks: Set<VoidFunction> | undefined = EventDispatcher.handlers.get(event);

		// Ensure We Have A Callback Set
		if (callbacks !== undefined) {

			// Delete Matching Callback
			callbacks.delete(callback);
		}
	}

	public static dispatch(event: Event, ...callbackParameters: any[]) {

		// Get Event Callbacks
		const callbacks: Set<VoidFunction> | undefined = EventDispatcher.handlers.get(event);

		// Ensure We Have A Callback Set
		if (callbacks !== undefined) {

			// Loop Through Event Callbacks
			callbacks.forEach((callback) => callback(...callbackParameters));
		}
	}

	private static handlers: Map<Event, Set<VoidFunction>> = new Map<Event, Set<VoidFunction>>();
}
